var _path, _path2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79854 9.67709C11.3691 9.10545 13.0369 8.84876 14.7067 8.92166C16.3765 8.99456 18.0155 9.39564 19.5303 10.102C19.5988 10.1339 19.6658 10.1689 19.7312 10.2068L41.6731 22.9268C45.9903 25.3705 45.9136 31.2588 41.6902 33.6995L25.4724 43.2393C25.4513 43.2517 25.4302 43.2638 25.4089 43.2755V37.3703L39.1185 29.3059L39.1397 29.2935C39.643 29.0039 39.793 28.6108 39.7935 28.3053C39.7939 28.0051 39.6519 27.6309 39.1607 27.3546L39.1325 27.3384L17.2831 14.6721C16.4011 14.2755 15.4514 14.0499 14.4846 14.0077C13.4827 13.964 12.4821 14.118 11.5397 14.461C10.5974 14.804 9.73182 15.3292 8.99247 16.0067C8.25311 16.6842 7.65444 17.5007 7.23062 18.4096C7.19228 18.4918 7.15011 18.571 7.10441 18.6471C5.82056 21.5093 5.09091 24.6733 5.09091 27.9999C5.09091 34.147 7.51023 39.7286 11.4546 43.8455V50.5701C11.367 50.5194 11.2815 50.4629 11.1985 50.4006C4.40337 45.2966 0 37.1621 0 27.9999C0 23.7385 0.977745 19.704 2.67269 16.0992C2.72599 15.9858 2.78657 15.8782 2.85363 15.7767C3.53948 14.4544 4.45283 13.2615 5.5531 12.2533C6.78536 11.1241 8.22796 10.2487 9.79854 9.67709Z",
    fill: "url(#paint0_linear_696_23778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9986 5.09091C25.682 5.09091 23.4487 5.43398 21.3449 6.07138L15.7266 2.82761C15.8491 2.76688 15.9727 2.70713 16.0973 2.64853C19.7123 0.948788 23.7482 0 27.9986 0C43.4626 0 55.9986 12.536 55.9986 28C55.9986 43.3473 43.6513 55.8104 28.3479 55.9979L28.3168 55.9982V56C28.2746 56 28.2325 55.9998 28.1903 55.9994C28.1264 55.9998 28.0625 56 27.9986 56V55.9959C26.4774 55.9569 24.9755 55.6384 23.568 55.0554C22.0625 54.4318 20.6945 53.5178 19.5422 52.3655C18.3899 51.2132 17.4759 49.8452 16.8523 48.3397C16.2286 46.8341 15.9077 45.2205 15.9077 43.5909V29.6666L20.9986 32.6058V43.5909C20.9986 44.5519 21.1879 45.5036 21.5556 46.3915C21.9234 47.2793 22.4625 48.0861 23.142 48.7656C23.8216 49.4452 24.6283 49.9842 25.5162 50.352C26.369 50.7052 27.2805 50.8938 28.2027 50.9082L28.2856 50.9073C40.8053 50.754 50.9077 40.5566 50.9077 28C50.9077 15.3477 40.6509 5.09091 27.9986 5.09091Z",
    fill: "url(#paint1_linear_696_23778)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4533,
    cy: 24.1818,
    r: 3.18182,
    fill: "#7F6AA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_23778",
    x1: 45.2019,
    y1: 8.90889,
    x2: -0.0444576,
    y2: 50.5197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163105,
    stopColor: "#D76F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F6AA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_696_23778",
    x1: 55.9986,
    y1: -2.08616e-7,
    x2: 13.5364,
    y2: 54.2869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB6F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BA29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.fb5010d2abc96cd3a3233319b0088f6e.svg";
export { ForwardRef as ReactComponent };